import 'victormono'

export { component as wrapRootElement } from './src/Main'
export const onInitialClientRender = require('./gatsby/browser/onInitialClientRender').default
export const onRouteUpdate = require('./gatsby/browser/onRouteUpdate').default
